import { SiteCollection } from "types";

/**
 * 現場名を取得します
 * @param SiteList Contextから取得した現場情報
 * @param id 指定の現場Id
 * @returns 現場名
 */
export const GetSiteName = (
  SiteList: SiteCollection[] | null,
  id: string | null
): string => {
  if (SiteList === null || id === null) return "";
  const site = SiteList.filter(f => f.id === id).shift();
  if (site) return site.name;
  return "";
};
